import request from '@/utils/request'

// ===== 名额申请表 =====
export function quoteList() {
  return request.post('/tool/quoteList')
}
export function quoteSave(data) {
  return request.post('/tool/quoteSave', data)
}
export function quoteDelete(id) {
  return request.post('/tool/quoteDelete', { id })
}

// ===== 兼职表 =====
export function workList() {
  return request.post('/tool/workList')
}
export function workSave(data) {
  return request.post('/tool/workSave', data)
}
export function workDelete(id) {
  return request.post('/tool/workDelete', { id })
}

// ===== 预览（对外催单分享链接） =====
// 名额申请表预览链接：POST title showNum totalNum indexNum surNum cols(数组)
export function quotePreviewUrl(data) {
  return request.post('/tool/quotePreviewUrl', data)
}
// 兼职表预览链接：POST title showNum totalNum indexNum cols(数组)
export function workPreviewUrl(data) {
  return request.post('/tool/workPreviewUrl', data)
}
// 预览页明细（免登录）：GET type company_id token
export function previewData(params) {
  return request.get('/tool/previewData', { params })
}